import { Badge } from '@/components/ui/Badge';
import { expiryState } from '@/features/admin/model';

export function ExpiryBadge({ expiresOn }: { expiresOn: string | null }) {
  const state = expiryState(expiresOn);
  if (state === 'expired') return <Badge variant="warning">Expired</Badge>;
  if (state === 'expiring') return <Badge variant="warning-soft">Expiring soon</Badge>;
  if (state === 'current') return <Badge variant="success-soft">Current</Badge>;
  return <span className="text-muted-foreground">No expiry</span>;
}
